module.exports = __webpack_public_path__ + "img/brand-block-7.dddb1002.png";